var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowArrowBottomOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 10,
    viewBox: "0 0 25 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.0001L8.74228e-07 5.78959e-05L25 6.00815e-05L12.5 10.0001Z",
    fill: "#50A0FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowArrowBottomOn);
export default __webpack_public_path__ + "static/media/flow_arrow_bottom_on.dd05cbd79261854117a54fa1077e07d8.svg";
export { ForwardRef as ReactComponent };